import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

import browserUtil from '../../utils/browser';
import config from '../../config';
import getIsServer from '../../utils/get-is-server';
import isFeatureEnabled from '../../utils/is-feature-enabled';

const createClient = () => {
  const isServer = getIsServer();
  const cache = new InMemoryCache();
  if (!isServer) {
    cache.restore(browserUtil.getWindow().__APOLLO_STATE__!);
  }
  const apiUrl = config.get('api:url');
  const isAuth0Enabled = isFeatureEnabled('auth0');
  const linkOpts = { headers: { 'auth-version': isAuth0Enabled ? '2' : '1' }, uri: `${apiUrl}/graphql` };
  const opts = {
    cache,
    clientAwareness: { name: config?.data?.app },
    link: new HttpLink(linkOpts),
    ssrMode: isServer,
  };
  return new ApolloClient(opts);
};

const client = createClient();
export default client;
